// extracted by mini-css-extract-plugin
module.exports = {"container":"QuoteLookup_container__2jETR"};